'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_JoinGeneralPracticeResponse$$anon$7() {
}
export { $c_Lapp_api_JoinGeneralPracticeResponse$$anon$7 as $c_Lapp_api_JoinGeneralPracticeResponse$$anon$7 };
$c_Lapp_api_JoinGeneralPracticeResponse$$anon$7.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_sr_AbstractPartialFunction();
$c_Lapp_api_JoinGeneralPracticeResponse$$anon$7.prototype.constructor = $c_Lapp_api_JoinGeneralPracticeResponse$$anon$7;
/** @constructor */
function $h_Lapp_api_JoinGeneralPracticeResponse$$anon$7() {
}
export { $h_Lapp_api_JoinGeneralPracticeResponse$$anon$7 as $h_Lapp_api_JoinGeneralPracticeResponse$$anon$7 };
$h_Lapp_api_JoinGeneralPracticeResponse$$anon$7.prototype = $c_Lapp_api_JoinGeneralPracticeResponse$$anon$7.prototype;
$c_Lapp_api_JoinGeneralPracticeResponse$$anon$7.prototype.isDefinedAt__O__Z = (function(x) {
  return false;
});
$c_Lapp_api_JoinGeneralPracticeResponse$$anon$7.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return (false ? x.name__T() : default$1.apply__O__O(x));
});
var $d_Lapp_api_JoinGeneralPracticeResponse$$anon$7 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_JoinGeneralPracticeResponse$$anon$7, "app.api.JoinGeneralPracticeResponse$$anon$7", ({
  Lapp_api_JoinGeneralPracticeResponse$$anon$7: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lapp_api_JoinGeneralPracticeResponse$$anon$7 as $d_Lapp_api_JoinGeneralPracticeResponse$$anon$7 };
//# sourceMappingURL=app.api.-Join-General-Practice-Response$$anon$7.js.map
